import {AxiosEsb, AxiosServer} from "../../utils";

let namespace = 'derWareHouseConfirmRd_';

//直接dispatch 为同步方法，比如  dispatch({type:'login/set',payload:{loading:false}});
//store 使用了thunk中间件，以下方法均为异步加载。

const derWareHouseConfirmAc = {
    SET: (value) => (dispatch) => {
        dispatch({ type: namespace + 'forcedUpdate', payload: value })
    },

    // 将上传的文件保存到derOrderFile表。
    TOFILE:(value)=>(dispatch,getState)=>{
        let Axios = AxiosServer();
        return  Axios.post('/derWareHouseFile/create',value).then((res)=>{

            //更新成功，重新获取数据
            dispatch({type: namespace+'forcedUpdate', payload: {newLoading: true}});

            return '上传成功';
        }).catch((err)=>{
            //dispatch({type:'login/set',payload:{loading:false}});
            console.log('err:',err);
            return 'error'
        })
    },
    DELETEFILE:(value)=>(dispatch,getState)=>{
        let Axios = AxiosServer();
        return  Axios.post('/derWareHouseFile/destroy',{id:value}).then((res)=>{

            //更新成功，重新获取数据
            dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}});
            return '上传成功';
        }).catch((err)=>{
            //dispatch({type:'login/set',payload:{loading:false}});
            console.log('err:',err);
            return 'error'
        })
    },
    ESBTOSFTP:(id)=> (dispatch,getState)=>{

        let Axios = AxiosEsb();

        return  Axios.post('/api/towxsbank/derWareHouse/sendToSftp',{id:id}).then((res)=>{

            //更新成功，重新获取数据
            dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}});
            return '更新成功'
        }).catch((err)=>{
            console.log('err:',err);
            return 'error'
        })

    },
    ESBTOSUBMIT:(value)=> (dispatch,getState)=>{

        let Axios = AxiosEsb();

        return  Axios.post('/api/towxsbank/submitWarehouseOrderInfoWh',{id:value.id,type:1}).then((res)=>{

            //提交成功，更新数据

            if (res.data.status){
                //更新后台为同意
                dispatch({type: namespace+'forcedUpdate', payload: {newLoading: true}});
                return res.data
            }

            return res.data;


        }).catch((err)=>{
            console.log('err:',err);
            return 'error'
        })

    },
}

export {
    derWareHouseConfirmAc
}